import { 
    PRODUCT_FAIL, PRODUCT_REQUEST, PRODUCT_SUCCESS
  } from '../constants/productConstants'
import axios from 'axios'

export const productList = () => async (dispatch) => {
    try {
        dispatch({
            type: PRODUCT_REQUEST
        })
  
        const { data } = await axios.get('product')

        dispatch({
            type: PRODUCT_SUCCESS,
            payload: data.data
        })
    } catch (e) {
        dispatch({
            type: PRODUCT_FAIL,
            payload: e
        })
    }
  }
  